export default "__VITE_ASSET__B54UBlYi__"